import {StyledListItemIcon, StyledMenuItem} from "../../StyledComponents";
import {Add24Icon} from "@kaltura/ds-react-icons";

export type ImportChannelActionProps = {
    label: string;
    channels: Record<string, string>[];
    url: string;
    channelId: number;
    errorMessage: string;
    populateModal: (data) => void;
}

/**
 * Channel Import Channel menu action item
 */
const ImportChannelAction = (props: ImportChannelActionProps) => {

    const {label, channels, url, channelId, errorMessage, populateModal} = props

    return (
        <StyledMenuItem
            href={""}
            component="a"
            onClick={(e) => {
                e.preventDefault();
                populateModal({channels, url, channelId, errorMessage, componentName: "ImportChannelModalContent"})
            }}
        >
            <StyledListItemIcon>
                <Add24Icon />
            </StyledListItemIcon>
            {label}
        </StyledMenuItem>
    )
};

export default ImportChannelAction;
